import focus from './focus'
import tooltip from './tooltip'
import onlyNumber from './onlyNumber'
import permission from './authPermission'

export default {
    install(Vue) {
        Vue.directive('focus', focus)
        Vue.directive('tooltip', tooltip)
        Vue.directive('only-number', onlyNumber)
        Vue.directive('permission', permission)
    }
}